<div #element class="transaction-list-item-wrapper h-full">
  @switch (transaction()._objectType) {
    @case ('bucketFundTransfer') {
      <div
        class="transaction-list-item transfer relative flex h-full w-full max-w-full items-center border-b border-border-muted bg-surface-elevated pl-4 pr-4 text-body-sm"
      >
        <button
          appUiButton
          appearance="ghost"
          tone="danger"
          class="transaction-list-item-transfer-delete mr-2 !min-h-9 !min-w-9 !p-0"
          type="button"
          (click)="openDeleteTransferModal(transaction())"
          aria-label="Delete transfer"
        >
          <ng-icon hlm size="sm" name="lucideX" />
        </button>
        <div class="flex min-w-0 flex-1 items-center justify-between gap-2">
          @if (transaction().netValue > 0) {
            <p class="min-w-0 truncate font-medium text-text">Transfer from {{ transaction().transferBucket.name }}</p>
          } @else if (transaction().netValue < 0) {
            <p class="min-w-0 truncate font-medium text-text">Transfer to {{ transaction().transferBucket.name }}</p>
          } @else {
            <p class="min-w-0 truncate font-medium text-text">Transfer {{ transaction().transferBucket.name }}</p>
          }
          <span
            class="shrink-0 tabular-nums font-semibold"
            [class.font-bold]="transaction().netValue > 0"
            [class.text-brand-primary-strong]="transaction().netValue > 0"
          >
            {{ transaction().amount | currency }}
          </span>
        </div>
      </div>
    }
    @case ('transaction') {
      <div
        class="transaction-list-item transaction group relative flex h-full w-full max-w-full items-center gap-[12px] border-b border-border-muted bg-surface-elevated transition-colors hover:bg-surface-muted"
        [class.bg-surface-tint]="isSelected()"
        data-testid="transaction-row"
        [attr.data-transaction-id]="transaction().id"
      >
        <div class="transaction-list-item-leading flex shrink-0 items-center self-center pl-6">
          @if (!transaction().locked?.value && interactive() && shouldShowSelectionCheckbox()) {
            <div class="transaction-list-item-leading-selection flex size-6 items-center justify-center">
              <app-ui-checkbox
                class="[&>div]:gap-0 [&>div>span]:hidden"
                [checked]="isSelected()"
                (checkedChange)="transactionSelectionToggled()"
                [ariaLabel]="'Select transaction ' + merchantDisplayName()"
              />
            </div>
          }
          @if (!transaction().locked?.value && !shouldShowSelectionCheckbox() && interactive()) {
            <button
              class="transaction-list-item-leading-logo shrink-0"
              type="button"
              [attr.aria-label]="'Select transaction ' + merchantDisplayName()"
              (click)="transactionSelectionToggled()"
            >
              @if (merchantLogoUrl(); as logoUrl) {
                <img
                  class="transaction-list-item-leading-logo__image border border-border-muted bg-surface-elevated shadow-raised"
                  [src]="logoUrl"
                  [alt]="merchantDisplayName() + ' logo'"
                  loading="lazy"
                  referrerpolicy="no-referrer"
                  draggable="false"
                />
              } @else {
                <span class="transaction-list-item-leading-logo__fallback border border-border-muted bg-surface-elevated shadow-raised inline-flex items-center justify-center text-sm font-bold text-text-muted" aria-hidden="true">
                  {{ merchantInitial() }}
                </span>
              }
            </button>
          }
          @if (!transaction().locked?.value && !interactive()) {
            <span class="transaction-list-item-leading-logo shrink-0" aria-hidden="true">
              @if (merchantLogoUrl(); as logoUrl) {
                <img
                  class="transaction-list-item-leading-logo__image border border-border-muted bg-surface-elevated shadow-raised"
                  [src]="logoUrl"
                  alt=""
                  loading="lazy"
                  referrerpolicy="no-referrer"
                  draggable="false"
                />
              } @else {
                <span class="transaction-list-item-leading-logo__fallback border border-border-muted bg-surface-elevated shadow-raised inline-flex items-center justify-center text-sm font-bold text-text-muted" aria-hidden="true">
                  {{ merchantInitial() }}
                </span>
              }
            </span>
          }
          @if (transaction().locked?.value) {
            <button
              appUiButton
              appearance="ghost"
              tone="neutral"
              class="!min-h-9 !min-w-9 !p-0 text-text-muted"
              type="button"
              (click)="whyLocked(transaction().locked?.reason ?? '')"
              aria-label="Why this transaction is locked"
            >
              <ng-icon hlm size="sm" name="lucideLock" />
            </button>
          }
        </div>
        <div class="relative flex h-full min-w-0 flex-1 items-stretch">
          <transaction-list-item-content
            class="flex min-w-0 flex-1"
            [transaction]="transaction()"
            [transactionDataSource]="transactionDataSource()"
            [buckets]="buckets()"
            [bucketIdentities]="bucketIdentities()"
            [showBucketSelector]="showBucketSelector()"
            [interactive]="interactive()"
            (selectedBucketChange)="selectedBucketChange($event)"
            (editRequested)="openEditTransactionModal()"
          />
        </div>
      </div>
    }
  }
</div>
